import { unwrapResult } from "@reduxjs/toolkit";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, Label, Row, Spinner } from "reactstrap";
import { Block, BlockHead, BlockHeadContent, BlockTitle, PreviewCard } from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { createCategory, updateCategory } from "../../redux/slices/categorySlice";
import Upload from "../app/file-manager/modals/Upload";

const CreateCategories = ({ onClose, isEdit = false, editData }) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);

  const { errors, register, handleSubmit, setValue } = useForm();

  const isLoading = useSelector((state) => state.category.isLoading);

  const onFormSubmit = async (data) => {
    const formData = new FormData();

    formData.append("name", data.name);
    if (files.length) {
      formData.append("image", files[0]);
    }

    try {
      const resultAction = await dispatch(
        isEdit
          ? updateCategory({
              data: formData,
              handleClose: onClose,
              id: editData?.id,
            })
          : createCategory({
              data: formData,
              handleClose: onClose,
            })
      );

      const originalPromiseResult = unwrapResult(resultAction);
      originalPromiseResult.handleClose && originalPromiseResult.handleClose();
    } catch (error) {}
  };

  const formClass = classNames({
    "form-validate": true,
    "is-alter": true,
  });

  useEffect(() => {
    if (editData && isEdit) {
      setValue("name", editData?.name);
    }
  }, [editData, isEdit, setValue]);

  return (
    <React.Fragment>
      <Head title={`${isEdit ? "Edit" : "Create"} Category`} />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                {isEdit ? `Edit Category (${editData?.name})` : "Create Category"}
              </BlockTitle>
            </BlockHeadContent>
          </BlockHead>
          <PreviewCard>
            <Form onSubmit={handleSubmit(onFormSubmit)} className={formClass}>
              <Row className="g-gs">
                {/* Patient Form */}
                <Col md="12">
                  <div className="form-group">
                    <Label className="form-label" htmlFor="fv-name">
                      Name
                    </Label>
                    <div className="form-control-wrap">
                      <input
                        ref={register({ required: true })}
                        type="text"
                        id="fv-name"
                        name="name"
                        className="form-control"
                      />
                      {errors.title && <span className="invalid">This field is required</span>}
                    </div>
                  </div>
                </Col>

                <Col md="12">
                  <div className="form-group">
                    <Label className="form-label" htmlFor="fv-work_type_id">
                      Image * (png, jpg, jpeg, webp) 1MB
                    </Label>
                    <div className="form-control-wrap">
                      <Upload
                        multiple={false}
                        files={files?.length ? files : editData?.image ? [editData?.image] : []}
                        setFiles={setFiles}
                      />
                    </div>
                  </div>
                </Col>

                <Col md="12">
                  <div className="flex gap-3 items-center">
                    <Button disabled={isLoading} color="primary" type="submit">
                      {isLoading ? <Spinner size="sm" color="light" /> : "Submit"}
                    </Button>

                    <Button disabled={isLoading} color={"danger"} type="reset" onClick={onClose}>
                      Cancel
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </PreviewCard>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default CreateCategories;
